import React from 'react';
import { Navigate, Outlet } from "react-router-dom";

export default function GuardedRoute (props) {
    const auth = props.isAuth;
    const isLogin = props.isLogin;
    return auth ? <Outlet></Outlet> : !isLogin ? <Navigate to="/login"></Navigate> : <Navigate to="/"></Navigate>
}